import { createSlice } from '@reduxjs/toolkit';

import { INoteState } from '../../types/note';

const initialState: INoteState = {
  isEditing: false,
  offer: undefined,
  position: 0,
};

const noteSlice = createSlice({
  name: 'note',
  initialState,
  reducers: {
    reset: () => initialState,
    setIsEditing: (state, action) => {
      state.isEditing = action.payload.isEditing;
      state.offer = action.payload.offer;
      state.position = action.payload.position;
    },
  },
  selectors: {
    selectIsNoteEditing: state => state.isEditing,
    selectNoteOffer: state => state.offer,
    selectNotePosition: state => state.position,
  },
});

export const {
  reducer: noteReducer,
  actions: noteActions,
  selectors: { selectIsNoteEditing, selectNoteOffer, selectNotePosition },
} = noteSlice;
